import React from 'react';
import { styled, SxProp } from 'dripsy';
import {
  EdgeInsets,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { ScrollView, IScrollViewProps } from '../common/ScrollView';
import {
  EmptyResultTypeEnum,
  EmptyResultView,
} from './EmptyResultView';
import { MainStackParamListType, screens } from '@navigation';
import { passIf } from '@utils';

const ScrollViewContainer = styled(ScrollView)({
  flex: 1,
  bg: '$background0',
});

function contentContainerStyle(insets: EdgeInsets): SxProp {
  return {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    pb: insets.bottom,
  };
}

export interface IScreenErrorViewProps extends IScrollViewProps {
  // FIXME: Add thunk error type
  error?: Record<string, any>;
}

type NavigationPropType =
  NativeStackNavigationProp<MainStackParamListType>;

export function ScreenErrorView({
  error,
  ...props
}: IScreenErrorViewProps) {
  const insets = useSafeAreaInsets();
  const nav = useNavigation<NavigationPropType>();
  function navigateToSubscription() {
    nav.navigate(screens.ProfileNavigator, {
      screen: screens.Subscription,
    });
  }

  // FIXME: Use error code instead of status
  const isNoAccessForTrialPlanError = error?.status === 403;
  const emptyResultViewType = isNoAccessForTrialPlanError
    ? EmptyResultTypeEnum.NoAccessForTrialPlan
    : EmptyResultTypeEnum.Error;

  return (
    <ScrollViewContainer
      contentContainerSx={contentContainerStyle(insets)}
      {...props}
    >
      <EmptyResultView
        type={emptyResultViewType}
        onPress={passIf(
          isNoAccessForTrialPlanError,
          navigateToSubscription,
        )}
      />
    </ScrollViewContainer>
  );
}
